import { getRequest , putRequest} from '../../../services/httpService';
import { ApprovalRuleDetail, ApprovalRulesListApiResponse, ApprovalRulesQueryParams, DocumentTypeOption } from './inventoryApproval.types';


//get all document types
export function getDocumentType(): Promise<DocumentTypeOption[]> {
  const url = '/approval-rules/document_types/';
  return getRequest(url, { responseType: 'json' });
}

export function getApprovalRules(params?: ApprovalRulesQueryParams): Promise<ApprovalRulesListApiResponse> {
  const url = '/approval-rules/';
  return getRequest(url, { responseType: 'json', params });
}

export function getApprovalRuleDetail(id: number): Promise<ApprovalRuleDetail> {
  const url = `/approval-rules/${id}/`;
  return getRequest(url, { responseType: 'json' });
}

export function activateApprovalRule(id: number): Promise<void> {
  const url = `/approval-rules/${id}/activate/`;
  return putRequest(url, {});
}